// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/DynamicFacet/_DynamicFacetValues.scss
// module id = 582
// module chunks = 2 8 88